// Static marketing content / site data.

export const NAV = [
  { label: 'Platform', to: '/platform' },
  { label: 'AI Trade Engine', to: '/ai-trade-engine' },
  { label: 'Strategies', to: '/strategies' },
  { label: 'Paid Strategies', to: '/paid-strategies' },
  { label: 'Backtesting', to: '/backtesting' },
  { label: 'Terminal', to: '/trade-terminal' },
  { label: 'Pricing', to: '/pricing' },
];

export const RESOURCES = [
  { label: 'Academy', to: '/academy' },
  { label: 'Community', to: '/community' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
  { label: 'FAQ', to: '/faq' },
];

export const MARKET_COVERAGE = [
  { icon: 'Bitcoin', title: 'Crypto', desc: 'Majors, alts and perpetuals.', tone: 'up' },
  { icon: 'Cpu', title: 'US Tech', desc: 'Leading technology equities.', tone: 'up' },
  { icon: 'DollarSign', title: 'Forex', desc: 'Global currency pairs.', tone: 'flat' },
  { icon: 'Gem', title: 'Commodities', desc: 'Gold and key commodities.', tone: 'up' },
];

export const PIPELINE = [
  { icon: 'Database', title: 'Market Data', desc: 'Continuous price, volume and structure data streamed across every supported market.' },
  { icon: 'ScanSearch', title: 'AI Scan', desc: 'Models scan conditions in real time, filtering noise from actionable context.' },
  { icon: 'Waves', title: 'Market Structure', desc: 'Trend, ranges, liquidity and key levels mapped for a clear read of the tape.' },
  { icon: 'Cpu', title: 'Strategy Engine', desc: 'Rules-based strategies evaluate the setup against defined logic and conditions.' },
  { icon: 'ShieldHalf', title: 'Risk Engine', desc: 'Every setup is stress-tested for risk, exposure and reward before it surfaces.' },
  { icon: 'Radio', title: 'Trade Signal', desc: 'A structured signal with entry, stop, targets and confidence \u2014 not just an arrow.' },
  { icon: 'Terminal', title: 'Execution', desc: 'Send trades to connected accounts with defined, disciplined risk.' },
];

export const STRATEGIES = [
  { name: 'Momentum', market: 'Crypto \u00b7 US Tech', timeframe: '1H \u2013 4H', risk: 'Moderate', win: '64.2%', pf: '1.94', dd: '9.4%', rr: '1:2.1', icon: 'TrendingUp' },
  { name: 'Breakout', market: 'Crypto \u00b7 Forex', timeframe: '15m \u2013 1H', risk: 'Higher', win: '58.7%', pf: '2.06', dd: '12.1%', rr: '1:2.6', icon: 'Zap' },
  { name: 'Mean Reversion', market: 'Forex \u00b7 Commodities', timeframe: '1H \u2013 1D', risk: 'Lower', win: '71.3%', pf: '1.81', dd: '7.2%', rr: '1:1.6', icon: 'Repeat' },
  { name: 'Volatility', market: 'Crypto \u00b7 Indices', timeframe: '5m \u2013 1H', risk: 'Higher', win: '61.5%', pf: '2.22', dd: '11.8%', rr: '1:2.4', icon: 'Activity' },
  { name: 'Multi-Factor AI', market: 'All markets', timeframe: 'Adaptive', risk: 'Balanced', win: '66.8%', pf: '2.18', dd: '8.9%', rr: '1:2.2', icon: 'BrainCircuit' },
];

export const BACKTEST = {
  initial: '$100,000', netProfit: '+$28,460', winRate: '67.4%', profitFactor: '2.18', maxDD: '8.9%', trades: 184, rr: '1:2',
  equity: [100, 101, 100.4, 103, 105, 104, 108, 112, 110, 115, 121, 119, 126, 130, 128, 134, 141, 138, 145, 128.46 + 100 - 28.46 + 28.46],
};

export const JOURNAL = [
  { label: 'Total P&L', value: '+$28,460', tone: 'up' },
  { label: 'Win Rate', value: '67.4%', tone: 'gold' },
  { label: 'Average R', value: '1.9R', tone: 'default' },
  { label: 'Profit Factor', value: '2.18', tone: 'up' },
  { label: 'Max Drawdown', value: '-8.9%', tone: 'down' },
  { label: 'Total Trades', value: '184', tone: 'default' },
];

export const HUMAN_CONTROL = [
  { icon: 'ScanSearch', title: 'AI Intelligence', desc: 'The engine scans continuously and surfaces the opportunity with full context.' },
  { icon: 'Eye', title: 'Human Decision', desc: 'You review the setup, the reasoning and the risk before anything happens.' },
  { icon: 'ShieldCheck', title: 'Controlled Execution', desc: 'Execute with defined risk across single or multiple connected accounts.' },
];

export const SECURITY = [
  { icon: 'KeyRound', title: 'Secure Authentication', desc: 'Email OTP and Google Authenticator with disciplined session controls.' },
  { icon: 'Plug', title: 'Exchange API Connectivity', desc: 'Connect exchange accounts with permission-based API access.' },
  { icon: 'Layers', title: 'Multi-Account Configuration', desc: 'Configure and manage multiple accounts with clean isolation.' },
  { icon: 'Lock', title: 'Tenant Isolation', desc: 'Strict separation so your data and access stay firmly your own.' },
  { icon: 'UserCheck', title: 'Permission-Based Access', desc: 'Granular, role-aware permissions across the platform.' },
  { icon: 'FileClock', title: 'Audit Trails', desc: 'Accountable, reviewable activity history you can trust.' },
];

export const PROOF = [
  { value: '4', label: 'Asset classes covered' },
  { value: '5', label: 'Core strategy families' },
  { value: '7', label: 'Intelligence pipeline stages' },
  { value: '24/7', label: 'Continuous market scanning' },
];

export const FAQS = [
  { q: 'What is Kalki AI?', a: 'Kalki AI is an AI-powered market intelligence and trading platform. It combines intelligent market scanning, quantitative strategies, backtesting, risk-aware trade analysis and multi-account execution into one institutional-grade workspace.' },
  { q: 'How does the AI Trade Engine work?', a: 'The engine continuously scans markets, reads structure, evaluates rules-based strategies and stress-tests each setup through a risk engine \u2014 then surfaces a structured signal with entry, stop, targets and a confidence score.' },
  { q: 'Can I backtest strategies?', a: 'Yes. You can validate strategies against historical data with clear metrics like net profit, win rate, profit factor and max drawdown, plus an interactive equity curve. Backtested results are illustrative and do not guarantee future performance.' },
  { q: 'Which markets are supported?', a: 'Kalki AI covers crypto, US tech, forex and commodities from one unified command surface.' },
  { q: 'Can I connect Binance?', a: 'Kalki AI supports exchange API connectivity with permission-based access. Available connections are configured within the platform.' },
  { q: 'Can I execute across multiple accounts?', a: 'Yes. The Trade Terminal supports single and multi-account execution with defined, disciplined risk.' },
  { q: 'What are Kalki Credits?', a: 'Kalki Credits are simple platform credits used for backtesting, pattern scans, technical scans and AI market analysis. They are included with subscriptions and available as one-time top-ups.' },
  { q: 'Does Kalki AI guarantee profits?', a: 'No. Kalki AI is a trading intelligence and execution platform. Historical and backtested results do not guarantee future performance. Trading involves significant risk.' },
];

export const FOOTER_LINKS = {
  Platform: [ { label: 'AI Trade Engine', to: '/ai-trade-engine' }, { label: 'Strategies', to: '/strategies' }, { label: 'Paid Strategies', to: '/paid-strategies' }, { label: 'Backtesting', to: '/backtesting' }, { label: 'Trade Terminal', to: '/trade-terminal' } ],
  Resources: [ { label: 'Academy', to: '/academy' }, { label: 'Community', to: '/community' }, { label: 'Documentation', to: '/academy' }, { label: 'FAQs', to: '/faq' } ],
  Company: [ { label: 'About', to: '/about' }, { label: 'Contact', to: '/contact' }, { label: 'Partners', to: '/affiliate' } ],
  Legal: [ { label: 'Terms', to: '/terms' }, { label: 'Privacy', to: '/privacy' }, { label: 'Risk Disclosure', to: '/terms#risk' } ],
};
